module.exports = __webpack_public_path__ + "img/alert_settings_icon.e413ea7a.svg";